/**
 * @generated SignedSource<<8ac2ad869d16e420668d6b24d618c89e>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* eslint-disable */

'use strict';

var node = (function(){
var v0 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "documentId"
},
v1 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "externalId"
},
v2 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "token"
},
v3 = [
  {
    "alias": null,
    "args": [
      {
        "kind": "Variable",
        "name": "documentId",
        "variableName": "documentId"
      },
      {
        "kind": "Variable",
        "name": "externalId",
        "variableName": "externalId"
      },
      {
        "kind": "Variable",
        "name": "token",
        "variableName": "token"
      }
    ],
    "concreteType": "BasicMutationResponse",
    "kind": "LinkedField",
    "name": "verifyLateEditToken",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "ok",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "error",
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": [
      (v0/*: any*/),
      (v1/*: any*/),
      (v2/*: any*/)
    ],
    "kind": "Fragment",
    "metadata": null,
    "name": "VerifyLateEditTokenMutation",
    "selections": (v3/*: any*/),
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [
      (v2/*: any*/),
      (v1/*: any*/),
      (v0/*: any*/)
    ],
    "kind": "Operation",
    "name": "VerifyLateEditTokenMutation",
    "selections": (v3/*: any*/)
  },
  "params": {
    "cacheID": "2ab74d9ac711ccd353ce7eb7f04c69c0",
    "id": null,
    "metadata": {},
    "name": "VerifyLateEditTokenMutation",
    "operationKind": "mutation",
    "text": "mutation VerifyLateEditTokenMutation(\n  $token: String!\n  $externalId: String!\n  $documentId: String!\n) {\n  verifyLateEditToken(token: $token, externalId: $externalId, documentId: $documentId) {\n    ok\n    error\n  }\n}\n"
  }
};
})();

node.hash = "da492c7967a65ad734a20d38b43f7890";

export default node;
